import { format, isValid } from 'date-fns';

const DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

function pad(value) {
  return String(value).padStart(2, '0');
}

export function isValidCalendarDate(year, month, day) {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return false;
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;
  const utc = new Date(Date.UTC(y, m - 1, d));
  return utc.getUTCFullYear() === y && utc.getUTCMonth() === m - 1 && utc.getUTCDate() === d;
}

/**
 * Calendar day as YYYY-MM-DD.
 * Date values use the local calendar (the day the user picked).
 * Strings keep the civil date before "T" and are never converted through UTC.
 */
export function toDateOnlyString(value) {
  if (value instanceof Date) {
    if (!isValid(value)) return null;
    const formatted = format(value, 'yyyy-MM-dd');
    const [y, m, d] = formatted.split('-').map(Number);
    return isValidCalendarDate(y, m, d) ? formatted : null;
  }

  if (typeof value === 'string') {
    const match = value.trim().match(DATE_PREFIX);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (!isValidCalendarDate(year, month, day)) return null;
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  return null;
}

/** Display a stored calendar day without shifting it across a timezone boundary. */
export function formatDateOnly(value, locale = 'ar-EG') {
  const iso = toDateOnlyString(value);
  if (!iso) return value ? String(value) : '-';
  const [year, month, day] = iso.split('-').map(Number);
  const utcNoon = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
  return utcNoon.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function wallClockDateTime(dateOnly, hours, minutes) {
  const iso = toDateOnlyString(dateOnly);
  if (!iso) return null;
  return `${iso}T${pad(hours)}:${pad(minutes)}:00`;
}
